import { Component } from '@angular/core';
import { ORCIDEducationEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Educations') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-orcideducation-form',
    templateUrl: './orcideducation.form.component.html'
})
export class ORCIDEducationFormComponent extends BaseFormComponent {
    public record!: ORCIDEducationEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

